<template>
	<a
		:href="urlWithUtm"
		target="_blank"
		@click="handleClick"
		class="group mt-8 flex items-center justify-between gap-2 border w-54 px-3.5 py-2 rounded-lg more-information-button-ga4"
		:class="
			portfolio == 7
				? 'border-orange-500 hover:bg-orange-50/50'
				: portfolio == 8
					? 'border-teal-500 hover:bg-teal-50/50'
					: 'border-blue-500 hover:bg-blue-50/50'
		"
	>
		<p
			class="text-sm font-semibold text-slate-950 transition-colors duration-200 capitalize"
			:class="
				portfolio == 7
					? 'group-hover:text-orange-500'
					: portfolio == 8
						? 'group-hover:text-teal-500'
						: 'group-hover:text-blue-500'
			"
		>
			{{ getTranslations("more information") }}
		</p>

		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="25"
			height="25"
			viewBox="0 0 25 25"
			fill="none"
			class="w-4 h-4 group-hover:translate-x-1 transition-transform duration-200"
		>
			<path
				d="M14.014 6.32757L20.2314 12.5388L14.014 18.75L12.4176 17.1155L15.8531 13.68L3.84378 13.68L3.84378 11.3976L15.8531 11.3976L12.4176 7.96208L14.014 6.32757Z"
				:fill="portfolio == 7 ? '#fb923c' : portfolio == 8 ? '#2dd4bf' : '#36F'"
			/>
		</svg>
	</a>
</template>

<script lang="js" src="./MoreButton.js"></script>
